var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avue-logo"},[(!_vm.isCollapse)?_c('img',{staticClass:"img1",attrs:{"alt":"","src":require("../../assets/images/logo.png")}}):_c('div',{staticClass:"img2"}),_c('transition-group',{attrs:{"name":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }